import styled from 'foundations-theming/utils';
import { fwcColor, fwcBorderRadius } from 'foundations-theming/utils/fwc';
import { jsx as _jsx } from "react/jsx-runtime";
export const getButtonTokens = size => {
  switch (size) {
    case 'xs':
    case 'extra-small':
      return {
        iconButtonSize: 'extra-small',
        paddingBlock: '100',
        maxBlockSize: '24px'
      };
    case 'sm':
    case 'small':
      return {
        iconButtonSize: 'extra-small',
        paddingBlock: '200',
        maxBlockSize: '32px'
      };
    case 'md':
    case 'medium':
    case 'default':
    default:
      return {
        iconButtonSize: 'small',
        paddingBlock: '300',
        maxBlockSize: '40px'
      };
  }
};
const ButtonSkeletonBox = styled.div.withConfig({
  displayName: "approvalEditorButtonSkeleton__ButtonSkeletonBox"
})(["background-color:", ";border-radius:", ";padding-block:", ";padding-inline:", ";display:inline-flex;inline-size:100px;block-size:", ";align-items:center;justify-content:center;user-select:none;cursor:pointer;max-inline-size:100%;overflow:hidden;box-sizing:border-box;"], ({
  theme
}) => theme.color[fwcColor('fwc-button-fill-primary-default')], ({
  theme
}) => theme.borderRadius[fwcBorderRadius('fwc-button')], ({
  theme,
  $paddingBlock
}) => theme.space[$paddingBlock], ({
  theme
}) => theme.space['300'], ({
  $blockSize
}) => $blockSize);
const ButtonSkeletonText = styled.div.withConfig({
  displayName: "approvalEditorButtonSkeleton__ButtonSkeletonText"
})(["border-radius:", ";background:", ";inline-size:40px;block-size:12px;opacity:0.5;"], ({
  theme
}) => theme.borderRadius['200'], ({
  theme
}) => theme.color[fwcColor('fwc-button-text-primary-default')]);

/**
 * Loading placeholder shared by the editor approval button surfaces
 * (`ApprovalEditorButtons` and `ApprovalEditorSingleButton`). Sized to match the
 * consumer's primary button via `size` so the layout does not shift once the
 * real button renders.
 */
export const ApprovalEditorButtonSkeleton = ({
  size
}) => {
  const {
    maxBlockSize,
    paddingBlock
  } = getButtonTokens(size);
  return /*#__PURE__*/_jsx(ButtonSkeletonBox, {
    "data-test-id": "loading-approval",
    $blockSize: maxBlockSize,
    $paddingBlock: paddingBlock,
    children: /*#__PURE__*/_jsx(ButtonSkeletonText, {})
  });
};